import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF } from '../../../Layout/tokens';

const PANELS: Record<string, TypedGroupviewPanelState> = {
  customerOrderMonitoring: {
    id: 'customerOrderMonitoring',
    contentComponent: 'customerOrderMonitoring',
    title: 'Customer Orders',
    params: { type: 'customerOrderMonitoring' },
  },
  customerTradeMonitoring: {
    id: 'customerTradeMonitoring',
    contentComponent: 'customerTradeMonitoring',
    title: 'Customer Trades',
    params: { type: 'customerTradeMonitoring' },
  },
  customerQuoteMonitoring: {
    id: 'customerQuoteMonitoring',
    contentComponent: 'customerQuoteMonitoring',
    title: 'Customer Quotes',
    params: { type: 'customerQuoteMonitoring' },
  },
  customerExecutionReportMonitoring: {
    id: 'customerExecutionReportMonitoring',
    contentComponent: 'customerExecutionReportMonitoring',
    title: 'Customer Execution Reports',
    params: { type: 'customerExecutionReportMonitoring' },
  },
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            visible: true,
            data: {
              views: ['customerOrderMonitoring'],
              activeView: 'customerOrderMonitoring',
              id: 'customerOrderMonitoring',
            },
            size: 800,
          },
          {
            type: LEAF,
            visible: true,
            data: {
              views: ['customerTradeMonitoring'],
              activeView: 'customerTradeMonitoring',
              id: 'customerTradeMonitoring',
            },
            size: 800,
          },
        ],
        size: 450,
      },
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            visible: true,
            data: {
              views: ['customerQuoteMonitoring'],
              activeView: 'customerQuoteMonitoring',
              id: 'customerQuoteMonitoring',
            },
            size: 800,
          },
          {
            type: LEAF,
            visible: true,
            data: {
              views: ['customerExecutionReportMonitoring'],
              activeView: 'customerExecutionReportMonitoring',
              id: 'customerExecutionReportMonitoring',
            },
            size: 800,
          },
        ],
        size: 450,
      },
    ],
    size: 900,
  },
  width: 1600,
  height: 900,
  orientation: Orientation.VERTICAL,
};

export const CUSTOMER_GRID_MONITORING_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
